module.exports = __webpack_public_path__ + "img/image-user-down.a9ebe3a2.svg";